import { AgGridReact, AgGridReactProps } from '@ag-grid-community/react'
import { ExcelExportParams } from '@ag-grid-community/core'
import CurvoLogo from '../curvo-logo-horizontal.png?inline'
import { UserPermissionFeature } from '../api'

export const CUSTOM_BASKET_PRODUCTS_COUNT_LIMIT = 75000
export const DOCUMENT_MAX_SIZE = 10 // in MB

export const ALL_ANALYZE_FEATURES = [
  UserPermissionFeature.Contracts,
  UserPermissionFeature.Baskets,
  UserPermissionFeature.BasketsReadonly,
  UserPermissionFeature.Spending,
  UserPermissionFeature.Reports,
]
export const ALL_ACTIVATE_FEATURES = [UserPermissionFeature.Opportunities, UserPermissionFeature.SourcingPlans]
export const ALL_ACTIVATE_EXPLICIT_FEATURES = [
  UserPermissionFeature.ProjectTracker,
  UserPermissionFeature.CxProjectTracker,
  UserPermissionFeature.Initiatives,
]
export const ALL_ENRICH_FEATURES = [
  UserPermissionFeature.TeamQueue,
  UserPermissionFeature.Catalog,
  UserPermissionFeature.ImportStudy,
]

export const enum LaunchDarklyFeatures {
  priceDirection = 'priceDirection',
  l12mBenchmarks = 'l12mBenchmarks',
  similarProducts = 'data-explorer-similar-products',
  extendedSimilarProducts = 'data-explorer-similar-products-extended',
  clinicalRelevantStudies = 'data-explorer-clinical-relevant-studies',
  basketSmartRules = 'basketSmartRules',
  contractMarketDefinition = 'contract-market-definition',
  markupRules = 'markup-rules',
  rfxRebateAndCustomFields = 'rfx-rebate-and-custom-fields',
  supplierPortal = 'supplier-portal',
}

export const GENERAL_INPUT_NAME_MAX_LENGTH = 75
export const BASKET_INPUT_NAME_MAX_LENGTH = 100
export const CURVO_XLSX_HEADER_COLOR = '162E63'

export const AgGridPropsForExcelExport = (
  gridRef: React.RefObject<AgGridReact>,
  { withoutCredit, ...exportParams }: ExcelExportParams & { withoutCredit?: boolean } = {},
): AgGridReactProps => ({
  suppressCsvExport: true,
  excelStyles: [
    {
      id: 'header',
      alignment: {
        vertical: 'Center',
      },
      font: {
        bold: true,
        color: '#FFFFFF',
      },
      interior: {
        color: CURVO_XLSX_HEADER_COLOR,
        pattern: 'Solid',
        patternColor: undefined,
      },
      borders: {
        borderTop: {
          color: '#000000',
          weight: 1,
        },
        borderBottom: {
          color: '#000000',
          weight: 1,
        },
        borderLeft: {
          color: '#000000',
          weight: 1,
        },
        borderRight: {
          color: '#000000',
          weight: 1,
        },
      },
    },
    {
      id: 'cell',
      borders: {
        borderTop: {
          color: '#000000',
          weight: 1,
        },
        borderBottom: {
          color: '#000000',
          weight: 1,
        },
        borderLeft: {
          color: '#000000',
          weight: 1,
        },
        borderRight: {
          color: '#000000',
          weight: 1,
        },
      },
    },
    {
      id: 'numberType',
      numberFormat: {
        format: '0.00',
      },
    },
    {
      id: 'booleanType',
      dataType: 'Boolean',
    },
    {
      id: 'stringType',
      dataType: 'String',
    },
    // {
    //   id: 'dateType',
    //   dataType: 'DateTime',
    //   numberFormat: {
    //     format: 'mm/dd/yyyy',
    //   },
    // },
  ],
  defaultExcelExportParams: {
    ...exportParams,
    prependContent: withoutCredit
      ? undefined
      : [
          [
            {
              data: {
                type: 'String',
                value: CurvoLogo, // see imageUtils
              },
              mergeAcross: 1,
            },
          ],
          [
            {
              data: {
                type: 'String',
                value: 'Copyright © Curvo Labs, Inc.',
              },
            },
          ],
        ],
    rowHeight: ({ rowIndex }) => (!withoutCredit && rowIndex === 1 ? 60 : 20),
    addImageToCell: (rowIndex, col, value) => {
      if (withoutCredit) {
        return undefined
      }
      if (rowIndex === 1 && gridRef.current!.columnApi.getAllDisplayedColumns()[0].getColId() === col.getColId()) {
        return {
          image: {
            id: 'logo',
            base64: value,
            imageType: 'png',
            width: 268,
            height: 60,
            fitCell: false,
            position: {
              colSpan: 2,
              row: 1,
            },
          },
        }
      }
      return undefined
    },
  },
})
